import Spinner from 'parkdepot-shared/components/Spinner'
import React, { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import Error from '@components/Error/Error.component'
import { SpinnerContainer } from './PaidOrder.style'
import OrderDetailedView from '@components/OrderDetailedView/OrderDetailedView.view'
import useGetOrderCacheFirst from '@hooks/useGetOrderCacheFirst'
import TagManager from 'react-gtm-module'
import { AdyenResultStatus } from '@customTypes/adyenResultStatus.enum'
import { useSendGTMEvent } from '@hooks/useSendGTMEvent.hook'

const PaidOrder = () => {
    const history = useHistory()
    const { search, pathname } = useLocation()
    const queryparams = new URLSearchParams(search)
    const plate = queryparams.get('plate')
    const orderId = queryparams.get('order_id')
    const status = queryparams.get('status')

    const { order, loading, error } = useGetOrderCacheFirst({ orderId, plate })
    const { sendCarpayPaymentSuccessEvent } = useSendGTMEvent()

    useEffect(() => {
        if (status?.toUpperCase() === AdyenResultStatus.AUTHORISED) {
            sendCarpayPaymentSuccessEvent()
        }
    }, [])

    if (loading) {
        return (
            <SpinnerContainer>
                <Spinner theme="primary" size="xl" />
            </SpinnerContainer>
        )
    }

    if (error || !plate || !order) {
        return <Error />
    }

    const onBackClick = () => history.replace('/')

    if (!order) {
        return (
            <SpinnerContainer>
                <Spinner theme="primary" size="xl" />
            </SpinnerContainer>
        )
    }

    return <OrderDetailedView selectedOrder={order} onBackClick={onBackClick} />
}

export default PaidOrder
